module.exports = __webpack_public_path__ + "img/tosee-saderat.31539bcf.png";